export const GET_ANALYTICS_REQUEST = 'GET_ANALYTICS_REQUEST'
export const GET_ANALYTICS_SUCCESS = 'GET_ANALYTICS_SUCCESS'
export const GET_ANALYTICS_FAIL = 'GET_ANALYTICS_FAIL'
export const GET_ANALYTICS_RESET = 'GET_ANALYTICS_RESET'
